import { h, render } from 'preact';
import Widget from './widget';
import {defaultConfiguration} from './default-configuration';

if (window.attachEvent) {
    window.attachEvent('onload', injectChat);
} else {
    window.addEventListener('load', injectChat, false);
}

function injectChat() {
    if (!window.chatgptAgentId) {
        console.error('APIキーエラー');
    } else {
        let root = document.createElement('div');
        const baseUrl = window.src
        root.id = 'chatgptAgentRoot';
        document.getElementsByTagName('body')[0].appendChild(root);
        const iFrameSrc = baseUrl + '/chat.html';
        const urlRoot = `${window.location.origin}/`;
        const host = urlRoot || 'unknown-host';
        const conf = { ...defaultConfiguration, ...window.chatgptCustomizations };

        render(
            <Widget chatgptAgentId={window.chatgptAgentId}
                    host={host}
                    isMobile={window.screen.width < 500}
                    iFrameSrc={iFrameSrc}
                    conf={conf}
                    src={baseUrl}
            />,
            root
        );
    }

}



// WEBPACK FOOTER //
// ./src/widget/widget-index.js